export default "__VITE_ASSET__14db0300__"